import { NonprofitCrm } from '~/pages/homepage/pages/features/nonprofit-crm'

export default NonprofitCrm
